import React, { useState } from 'react';
import clsx from 'clsx';
import styles from './Faq.module.scss';
import { FAQ_CONTENT } from '../../constants/marketingContent';

const Faq = () => {
  const [openedId, setOpenedId] = useState(FAQ_CONTENT.items[0]?.id ?? null);

  const handleToggle = (id) => {
    setOpenedId((prev) => (prev === id ? null : id));
  };

  return (
    <section className={clsx(styles.wrap)} id="faq">
      <div className="container">
        <div className={clsx(styles.head)}>
          <div className={clsx(styles.title, 'title')}>{FAQ_CONTENT.title}</div>
          <p className={clsx(styles.subtitle)}>{FAQ_CONTENT.subtitle}</p>
        </div>

        <div className={clsx(styles.list)}>
          {FAQ_CONTENT.items.map((item) => (
            <div className={clsx(styles.item, openedId === item.id && styles.itemOpen)} key={item.id}>
              <button
                type="button"
                className={clsx(styles.trigger)}
                onClick={() => handleToggle(item.id)}
                aria-expanded={openedId === item.id}
                aria-controls={`${item.id}-answer`}
              >
                <span className={clsx(styles.question)}>{item.question}</span>
                <span className={clsx(styles.icon)} aria-hidden="true">
                  +
                </span>
              </button>

              <div
                className={clsx(styles.answerWrap, openedId === item.id && styles.answerWrapOpen)}
                id={`${item.id}-answer`}
              >
                <div className={clsx(styles.answerInner)}>
                  <div className={clsx(styles.answer)}>{item.answer}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Faq;
